import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M16.556 16.556 21 21"
      }),
      _createElementVNode("path", { d: "M18.778 9.889A8.889 8.889 0 1 1 1 9.889a8.889 8.889 0 0 1 17.778 0Z" })
    ], -1)
  ]))]))
}
export default { render: render }